import ModalOAContact from "../components/modalOAContact";

export default function OAContactPage() {
  return <ModalOAContact open={true} onClose={() => window.open("/", "_self")} />;
}
